import { useMemo } from 'react';

export const useFullName = (firstName: string | undefined, lastName: string | undefined) => {
  return useMemo(() => [firstName, lastName].filter((v) => v).join(' '), [firstName, lastName]);
};
